import { playerDataIndex } from '~/apps/product-plus/search-domain/indexes';
import { buildPlayerDataQuery } from '~/apps/product-plus/search-domain/pipelines/player-data/build-query';
import {
  getPlayerDataBaseFilters,
  getPlayerDataFacetAttributes,
  getPlayerDataSearchSettings,
  getPlayerDataSorting,
} from '~/apps/product-plus/search-domain/pipelines/player-data/query-config';
import { transformPlayerDataResponse } from '~/apps/product-plus/search-domain/pipelines/player-data/transform-response';
import { type SearchPipelineDefinition, type SearchUiState } from '~/apps/product-plus/search-domain/types';

const resolvePlayerDataSorting = () => getPlayerDataSorting();

export const playerDataPipelineDefinition: SearchPipelineDefinition<SearchUiState, unknown> = {
  buildSearchRequest: buildPlayerDataQuery,
  facetAttributes: context => getPlayerDataFacetAttributes(context),
  getBaseFilters: context => getPlayerDataBaseFilters(context),
  getSearchUiConfig: () => ({
    searchAttributes: getPlayerDataSearchSettings().search ?? [],
    sorting: resolvePlayerDataSorting,
  }),
  getSorting: resolvePlayerDataSorting,
  id: playerDataIndex,
  searchSettings: () => getPlayerDataSearchSettings(),
  transformResponse: transformPlayerDataResponse,
};
